module.exports = __webpack_public_path__ + "img/user_icon.53090f4c.png";